import { motion } from "framer-motion";
import { Phone, MessageCircle } from "lucide-react";
import { CONTACT } from "@/data";

export const FloatingButtons = () => (
  <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3" data-testid="floating-buttons">
    <motion.a
      data-testid="floating-whatsapp"
      href={`https://wa.me/${CONTACT.whatsapp}`}
      target="_blank"
      rel="noopener noreferrer"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.4, type: "spring", stiffness: 260, damping: 18 }}
      className="relative grid place-items-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/30 hover:scale-105 transition-transform"
      aria-label="WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <MessageCircle className="h-6 w-6 relative" />
    </motion.a>
    <motion.a
      data-testid="floating-phone"
      href={`tel:${CONTACT.phones[0].tel}`}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.55, type: "spring", stiffness: 260, damping: 18 }}
      className="grid place-items-center h-14 w-14 rounded-full bg-[#E85D04] text-white shadow-lg shadow-[#E85D04]/30 hover:scale-105 transition-transform"
      aria-label="Call"
    >
      <Phone className="h-6 w-6" />
    </motion.a>
  </div>
);
